import { NUMERIC_FIELDS } from "./magic-field-types";

export default function isNumericField(type) {
    return NUMERIC_FIELDS.includes(type);
}